import { render, staticRenderFns } from "./PageWithoutNavbar.vue?vue&type=template&id=44dc15c6&scoped=true&"
import script from "./PageWithoutNavbar.vue?vue&type=script&lang=js&"
export * from "./PageWithoutNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PageWithoutNavbar.vue?vue&type=style&index=0&id=44dc15c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc15c6",
  null
  
)

export default component.exports